import { SELECT_SIZE, UPDATE_STATS, SET_MODE, SHOW_HELP, SET_TOGO, PAUSE } from './actions';
import * as f from '../logic';
import _ from 'lodash';
import { dbdel } from '../../HOME/utils';
import { HELPED_KEY } from '../const';

export default (state = {}, action) => {
  switch (action.type) {
    case SET_MODE:
      return { ...state, mode: action.mode };
    case SELECT_SIZE:
      return { ...state, size: action.size };
    case UPDATE_STATS:
      return onUpdateStats(state, action.stats);
    case SHOW_HELP:
      return { ...state, help: action.show };
    case SET_TOGO:
      return { ...state, togo: action.togo || 0 };
    case PAUSE:
      return { ...state, paused: action.on };
    case HELPED_KEY:
      return { ...state, helped: true };
    default:
      return state;
  }
};

function onUpdateStats(state, stats) {
  if (!stats) {
    dbdel(f.statsKey(state));
    stats = { plays: 0, aggScore: 0, aveScore: 0, bestScore: 0 };
  } else {
    let { plays, aggScore, bestScore } = stats;

    const aveScore = plays === 0 ? 0 : _.round((aggScore || 0) / plays);

    stats = { plays, aggScore, aveScore, bestScore };
  }

  return { ...state, stats };
}
